import { dom } from "../dom";
import { state } from "../state";

/**
 * Позиционирование и открытие/закрытие меню «+» (добавление IFC).
 * Попап открывается по центру верхней панели вкладок.
 */
export function closeIfcAddMenu(): void {
  dom.ifcAddMenu.classList.remove("is-open");
  dom.ifcAddMenu.setAttribute("aria-hidden", "true");
  state.ifcAddMenuOpen = false;
}

export function openIfcAddMenu(anchorElement: HTMLElement): void {
  if (!anchorElement) {
    return;
  }
  const tabsRect = dom.ifcTabsElement.getBoundingClientRect();
  const pad = 8;
  const menuW = Math.min(340, Math.max(220, window.innerWidth - 2 * pad));
  const top = tabsRect.bottom + window.scrollY + 8;
  let left = tabsRect.left + window.scrollX + (tabsRect.width - menuW) / 2;
  const maxLeft = window.scrollX + window.innerWidth - menuW - pad;
  const minLeft = window.scrollX + pad;
  left = Math.min(Math.max(left, minLeft), maxLeft);
  dom.ifcAddMenu.style.top = `${top}px`;
  dom.ifcAddMenu.style.left = `${left}px`;
  dom.ifcAddMenu.classList.add("is-open");
  dom.ifcAddMenu.setAttribute("aria-hidden", "false");
  state.ifcAddMenuOpen = true;
}
